import PropTypes from 'prop-types'

import ModelListModel from '../ModelListModel'

function BoardModelCard({
  model = {},
  group = '',
  href = '',
  showFollowers = false,
}) {
  return (
    <ModelListModel
      {...model}
      group={group}
      href={href}
      withBoard
      showFollowers={showFollowers}
    />
  )
}

BoardModelCard.propTypes = {
  model: PropTypes.object,
  group: PropTypes.string,
  href: PropTypes.string,
  showFollowers: PropTypes.bool,
}

export default BoardModelCard
